import app from './app';
import { getEnvValue, getExternalAssetFilePath } from './utils';

const defaultImageUrl = '/assets/elvorscan-og.svg';

const meta = Object.freeze({
  promoteBlockscoutInTitle: false,
  og: {
    description: getEnvValue('NEXT_PUBLIC_OG_DESCRIPTION') || 'Elvor Scan is the premium blockchain explorer for the Elvor ecosystem, built for real-time transaction, address, token, and contract insights.',
    imageUrl: app.baseUrl + (getExternalAssetFilePath('NEXT_PUBLIC_OG_IMAGE_URL') || defaultImageUrl),
    enhancedDataEnabled: getEnvValue('NEXT_PUBLIC_OG_ENHANCED_DATA_ENABLED') === 'true',
  },
  seo: {
    enhancedDataEnabled: getEnvValue('NEXT_PUBLIC_SEO_ENHANCED_DATA_ENABLED') === 'true',
  },
});

export default meta;
